import React from 'react';

const AsesoriaIcon = () => (
    <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.3002 12.1672V18.2142H14.7002V13.767H2.3002V18.2142H0.700195V12.1672H16.3002ZM8.53284 0.125977L13.9068 5.49999L8.53284 10.874L3.15882 5.49999L8.53284 0.125977ZM8.53238 2.38827L5.42111 5.49954L8.53238 8.61081L11.6437 5.49954L8.53238 2.38827Z" fill="#0D559B"/>
    </svg>
);

export default AsesoriaIcon;
